module.exports = {"apiUrl":"http://localhost:5000/api/v1.0/","cmsUrl":"http://localhost:8080"}


//////////////////
// WEBPACK FOOTER
// ./src/Config/dev-config.json
// module id = 1080
// module chunks = 0